// Kviz.jsx (основной компонент квиза)
import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;
import { IMaskInput } from 'react-imask';
import axios from 'axios';

import MadeInRussia from './MadeInRussia';

// Очищенные данные квиза (только используемое)
const quizData = {
  "widget": {
    "id": "89735",
    "site_id": "511649"
  },
  "settings": {
    "name": "Квиз с боковой панели",
    "name_offer": "Подберем оптовую партию жидкостей для вашего бизнеса",
    "get_name": "yes",
    "get_phone": "yes",
    "get_email": "hide",
    "show_expert": 1,
    "color_elements": "#009ee3",
    "color_background": "rgba(243,14,33,1)",
    "color_text": "rgba(255,255,255,1)",
    "widget_text": "Запрос КП",
    "expert_img_src": "/assets/images/kviz/elena.jpeg",
    "name_expert": "Фирюлина Елена",
    "position_expert": "Менеджер технолог",
    "widget_btn_text": "Отправить",
    "widget_page_after_thanks_text": "Мы свяжемся с Вами для уточнения деталей заказа",
    "widget_page_thanks_text": "Спасибо!",
    "widget_action_text": "Укажите свои данные — мы отправим по вашему запросу подборку подходящего состава, расчет и сроки поставки.",
    "agreement_personal_data": 1,
    "agreement_custom_text": "Согласен на обработку персональных данных и принимаю <a href=\"https://himavangard.ru/policy/\">условия соглашения</a>",
    "color_background_quiz_body": "#EFEFF4",
    "color_background_sidebar": "#FFFFFF",
    "color_inputs": "#FFFFFF",
    "start_page_text_title": "Получить КП",
    "start_page_text_content": "Отправим предложение по оптовым поставкам сегодня. Расчет стоимости и срок доставки.",
    "start_page_button_text": "Начать расчёт",
    "show_start_page": 1,
    "translate": {
      "back": "Назад",
      "next": "Далее",
      "form_name": "Ваше имя",
      "form_phone": "Ваш телефон",
      "form_email": "Ваш email",
      "brand": "Сделано в"
    }
  },
  "questions": [
    {
      "id": "556721",
      "question": "Какая сфера применения продукции вас интересует?",
      "prompt": "Укажите оборудование, мы предложим варианты поставок",
      "answer_variant_option": "img",
      "variants": [
        {
          "id": "2024954",
          "image": "/assets/images/kviz/service.jpeg",
          "answer": "Автосервис / Автотранспорт",
          "prompt": "(Антифризы, Тосолы, стеклоомыватели)"
        },
        {
          "id": "2025053",
          "image": "/assets/images/kviz/prom.jpeg",
          "answer": "Промышленность / Производство",
          "prompt": "(Химическая продукция, Химическое сырье и компоненты)"
        },
        {
          "id": "2025056",
          "image": "/assets/images/kviz/otoplenie.jpeg",
          "answer": "Отопление / охлаждение зданий",
          "prompt": "(Теплоносители для систем отопления, котельные воды, Хладоносители)"
        },
        {
          "id": "2025059",
          "image": "/assets/images/kviz/antiled2.jpg",
          "answer": "Антиобледенители",
          "prompt": "(аэропорты, авиация, ж/д, специализированная техника)"
        },
        {
          "id": "2025062",
          "image": "/assets/images/kviz/pishevaya.jpeg",
          "answer": "Пищевая / фармацевтическая",
          "prompt": "(ECO-составы, Антибактериальные средства)"
        },
        {
          "id": "2025065",
          "image": "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><rect width='100' height='100' rx='16' fill='%23f3f4f6'/><text x='50' y='72' font-size='64' text-anchor='middle' fill='%236b7280'>?</text></svg>",
          "answer": "Другое",
          "prompt": "Не нашли нужную продукцию?"
        }
      ]
    },
    {
      "id": "556742",
      "question": "Какой объём потребляете в год?",
      "prompt": "",
      "answer_variant_option": "text",
      "variants": [
        {
          "id": "2025107",
          "answer": "До 5 тонн"
        },
        {
          "id": "2025110",
          "answer": "6-20 тонн"
        },
        {
          "id": "2025113",
          "answer": "21-100 тонн"
        },
        {
          "id": "2025116",
          "answer": "Более 100 тонн"
        }
      ]
    },
    {
      "id": "556900",
      "question": "Когда нужна поставка?",
      "prompt": "",
      "answer_variant_option": "text",
      "variants": [
        {
          "id": "2025688",
          "answer": "Срочно (1–3 дня)"
        },
        {
          "id": "2025691",
          "answer": "В течение недели"
        },
        {
          "id": "2025694",
          "answer": "Планово (2–4 недели)"
        },
        {
          "id": "2025697",
          "answer": "Уточняю бюджет / пока смотрю"
        }
      ]
    }
  ],
  "hideCopyright": true,
  "partnerLink": "https://envybox.io/products/kvizy/?utm_source=widget&utm_medium=quiz&utm_campaign=himavangard.ru"
};

class Kviz extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
      answers: {},
      showForm: false,
      showStartPage: false,
      customVolume: '',
      showCustomInput: false,
      formData: {
        productName: '',
        quantity: '',
        companyName: '',
        contactPerson: '',
        phone: '',
        email: '',
        comment: '',
        agreement: true
      },
      errors: {},
      isSending: false,
      submitted: false,
      notification: {
        show: false,
        type: 'success',
        message: ''
      }
    };
  }

  // Получение настроек (из props или из дефолтных данных)
  getSettings = () => {
    return this.props.data?.settings || quizData.settings || {};
  };

  // Получение вопросов (из props или из дефолтных данных)
  getQuestions = () => {
    return this.props.data?.questions || quizData.questions || [];
  };

  // Получение цвета элементов
  getColorElements = () => {
    const settings = this.getSettings();
    return settings.color_elements || '#009ee3';
  };

  // Начать квиз
  handleStartQuiz = () => {
    this.setState({ showStartPage: false });
  };

  // Обработка ответа на вопрос
  handleAnswer = (questionId, answer, variantId = null) => {
    this.setState(prevState => ({
      answers: {
        ...prevState.answers,
        [questionId]: {
          answer,
          variantId
        }
      },
      showCustomInput: false,
      customVolume: ''
    }));

    const questions = this.getQuestions();
    if (this.state.currentStep + 1 < questions.length) {
      this.setState({ currentStep: this.state.currentStep + 1 });
    } else {
      this.setState({ showForm: true });
    }
  };

  // Обработка "Другое" для объема
  handleOtherOption = () => {
    this.setState({ showCustomInput: true });
  };

  handleCustomVolumeChange = (e) => {
    this.setState({ customVolume: e.target.value });
  };

  handleSaveCustomVolume = (questionId) => {
    if (this.state.customVolume.trim()) {
      this.handleAnswer(questionId, this.state.customVolume + ' тонн', 'custom');
    }
  };

  // Обработка формы
  handleFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: type === 'checkbox' ? checked : value
      },
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }));
  };

  handlePhoneChange = (value) => {
    this.setState(prevState => ({
      formData: { ...prevState.formData, phone: value },
      errors: { ...prevState.errors, phone: '' }
    }));
  };

  showNotification = (type, message) => {
    const settings = this.getSettings();
    this.setState({
      notification: {
        show: true,
        type: type,
        message: message || (type === 'success' ? settings.widget_page_thanks_text || 'Спасибо!' : 'Произошла ошибка при отправке')
      }
    });

    if (this.notificationTimeout) clearTimeout(this.notificationTimeout);
    this.notificationTimeout = setTimeout(() => {
      this.setState({ notification: { ...this.state.notification, show: false } });
    }, 5000);
  };

  validateForm = () => {
    const { formData } = this.state;
    const errors = {};

    // Продукт — обязательное
    if (!formData.productName?.trim()) {
      errors.productName = 'Укажите продукт';
    }

    // Контактное лицо — обязательное
    if (!formData.contactPerson?.trim()) {
      errors.contactPerson = 'Контактное лицо обязательно';
    }

    // Телефон — обязательное
    if (!formData.phone?.trim()) {
      errors.phone = 'Укажите ваш телефон';
    } else {
      const phoneDigits = formData.phone.replace(/\D/g, '');
      if (phoneDigits.length < 11) {
        errors.phone = 'Введите полный номер телефона';
      }
    }

    // Email — обязательное + проверка формата
    if (!formData.email?.trim()) {
      errors.email = 'E-mail обязателен';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Введите корректный email';
    }

    if (!formData.agreement) {
      errors.agreement = 'Необходимо согласие на обработку данных';
    }

    return errors;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.setState({ isSending: true });

    const settings = this.getSettings();
    const { formData, answers } = this.state;
    const questions = this.getQuestions();

    // Формируем массив объектов с русскими name и value для ответов квиза
    const quizAnswersArray = [
      {
        name: "Сфера применения",
        value: answers["556721"]?.answer || ''
      },
      {
        name: "Объем потребления в год",
        value: answers["556742"]?.answer || ''
      },
      {
        name: "Срок поставки",
        value: answers["556900"]?.answer || ''
      },
      {
        name: "Полные ответы",
        value: questions.map(q => {
          const answer = answers[q.id]?.answer || 'Не указано';
          return `${q.question}: ${answer}`;
        }).join('\n')
      }
    ];

    // Фильтруем пустые значения
    const filteredAnswers = quizAnswersArray.filter(item => item.value);

    const apiUrl = process.env.REACT_APP_API_URL || '';

    axios.post(apiUrl, {
      'content_type': 'application/json',
      'action': 'feedback_form',
      'form': settings.name || 'Квиз',
      'name': formData.contactPerson || '',
      'productName': formData.productName || '',
      'quantity': formData.quantity || '',
      'companyName': formData.companyName || '',
      'phone': formData.phone || '',
      'email': formData.email || '',
      'comment': formData.comment || '',
      'json': JSON.stringify(filteredAnswers)
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Request-Source': 'Node.js'
      }
    }).then((response) => {
      if (response.data.result) {
        this.showNotification('success');
        this.setState({ submitted: true, showForm: false });
        
        setTimeout(() => {
          if (this.props.hideFn) {
            this.props.hideFn();
          }
        }, 2000);

        setTimeout(() => {
          if (typeof window !== 'undefined') {
            window.location.href = '/thanks';
          }
        }, 1500);
      } else {
        this.showNotification('error', response.data.message || 'Ошибка при отправке');
      }
    }).catch(error => {
      console.error('Error sending form:', error);
      this.showNotification('error');
    }).finally(() => {
      this.setState({ isSending: false });
    });
  };

  handleBackToQuiz = () => {
    this.setState({ showForm: false });
  };

  handleRestart = () => {
    this.setState({
      currentStep: 0,
      answers: {},
      showForm: false,
      showStartPage: false,
      customVolume: '',
      showCustomInput: false,
      formData: { productName: '', quantity: '', companyName: '', contactPerson: '', phone: '', email: '', comment: '', agreement: true },
      errors: {},
      submitted: false,
      notification: { show: false, type: 'success', message: '' }
    });
  };

  renderStartPage = () => {
    const settings = this.getSettings();
    const colorElements = this.getColorElements();

    return (
      <div className="animate-fadeKviz">
        <div className="text-center">
          {settings.start_page_text_title && (
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4" style={{ color: '#000000' }}>
              {settings.start_page_text_title}
            </h1>
          )}
          {settings.start_page_text_content && (
            <p className="text-gray-600 mb-6 text-sm sm:text-base">{settings.start_page_text_content}</p>
          )}
          <button
            onClick={this.handleStartQuiz}
            className="px-6 py-2 sm:py-3 rounded-xl font-semibold text-white transition-all hover:opacity-90 text-sm sm:text-base"
            style={{ backgroundColor: colorElements }}
          >
            {settings.start_page_button_text || 'Начать расчёт'}
          </button>
        </div>
      </div>
    );
  };

  renderQuestion = (question, index) => {
    const settings = this.getSettings();
    const colorElements = this.getColorElements();
    const totalQuestions = this.getQuestions().length;
    const isVolumeQuestion = question.id === "556742";
    const isImageOption = question.answer_variant_option === 'img';

    return (
      <div key={question.id} className="animate-fadeKviz">
        <div className="mb-6">
          <div className="flex justify-between text-xs sm:text-sm text-gray-500 mb-2">
            <span>Вопрос {index + 1} из {totalQuestions}</span>
            <span>{Math.round(((index + 1) / totalQuestions) * 100)}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
            <div className="h-full rounded-full transition-all duration-300" style={{ width: `${((index + 1) / totalQuestions) * 100}%`, backgroundColor: colorElements }} />
          </div>
        </div>

        <h2 className="text-lg sm:text-xl md:text-2xl font-bold mb-3 text-gray-900">{question.question}</h2>
        {question.prompt && <p className="text-gray-500 mb-5 text-xs sm:text-sm">{question.prompt}</p>}

        <div className={`grid gap-3 mt-5 ${isImageOption ? 'grid-cols-1 sm:grid-cols-2 gap-4' : 'grid-cols-1'}`}>
          {question.variants?.map((variant) => {
            const isSelected = this.state.answers[question.id]?.variantId === variant.id;
            
            if (isImageOption && variant.image) {
              return (
                <button key={variant.id} onClick={() => this.handleAnswer(question.id, variant.answer, variant.id)}
                  className={`text-left p-3 rounded-xl border-2 transition-all ${isSelected ? 'bg-cyan-50' : 'border-gray-200 hover:border-gray-300 bg-white'}`}
                  style={{ borderColor: isSelected ? colorElements : undefined }}>
                  <div className="flex gap-3">
                    <img src={variant.image} alt={variant.answer} className="w-16 h-16 object-cover rounded-lg flex-shrink-0" onError={(e) => { e.target.style.display = 'none'; }} />
                    <div className="flex-1">
                      <div className="font-semibold text-gray-900 text-sm">{variant.answer}</div>
                      {variant.prompt && <div className="text-xs text-gray-500 mt-1">{variant.prompt}</div>}
                    </div>
                  </div>
                </button>
              );
            }
            
            return (
              <button key={variant.id} onClick={() => this.handleAnswer(question.id, variant.answer, variant.id)}
                className={`p-3 rounded-xl border-2 transition-all text-left ${isSelected ? 'bg-cyan-50 font-medium' : 'border-gray-200 hover:border-gray-300 bg-white'}`}
                style={{ borderColor: isSelected ? colorElements : undefined }}>
                <span className="text-gray-900 text-sm">{variant.answer}</span>
              </button>
            );
          })}

          {isVolumeQuestion && !this.state.showCustomInput && (
            <button onClick={this.handleOtherOption} className="p-3 rounded-xl border-2 border-dashed border-gray-300 hover:border-gray-400 bg-white text-left">
              <span className="text-gray-900 text-sm">📝 Другое (указать свой объем)</span>
            </button>
          )}
        </div>

        {isVolumeQuestion && this.state.showCustomInput && (
          <div className="mt-4 p-3 bg-gray-50 rounded-xl animate-fadeKviz">
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">Укажите ваш объем в тоннах:</label>
            <div className="flex gap-2 flex-col sm:flex-row">
              <input type="text" value={this.state.customVolume} onChange={this.handleCustomVolumeChange}
                placeholder="Например: 150 тонн" className="flex-1 px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 text-sm" autoFocus />
              <button onClick={() => this.handleSaveCustomVolume(question.id)} disabled={!this.state.customVolume.trim()}
                className="px-4 py-2 rounded-lg font-medium text-white transition-all hover:opacity-90 disabled:opacity-50 text-sm whitespace-nowrap"
                style={{ backgroundColor: colorElements }}>Сохранить</button>
            </div>
            <button onClick={() => this.setState({ showCustomInput: false, customVolume: '' })} className="mt-2 text-xs text-gray-400 hover:text-gray-600">← Отмена</button>
          </div>
        )}

        {index > 0 && (
          <button onClick={() => this.setState({ currentStep: index - 1 })} className="mt-5 text-xs text-gray-400 hover:text-gray-600">
            ← {settings.translate?.back || 'Назад'}
          </button>
        )}
      </div>
    );
  };

  renderForm = () => {
    const settings = this.getSettings();
    const colorElements = this.getColorElements();
    const { formData, errors, isSending } = this.state;
    const questions = this.getQuestions();

    const userAnswers = questions.map(q => ({
      question: q.question,
      answer: this.state.answers[q.id]?.answer || 'Не выбран'
    }));

    return (
      <div className="animate-fadeKviz">
        <div className="text-center mb-6">
          <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-2">{settings.name_offer}</h2>
          <p className="text-gray-600 text-xs sm:text-sm">{settings.widget_action_text}</p>
        </div>

        <div className="bg-gray-50 rounded-xl p-3 mb-5">
          <h3 className="font-semibold text-gray-900 mb-2 text-xs sm:text-sm">Ваши ответы:</h3>
          <div className="space-y-1">
            {userAnswers.map((item, idx) => (
              <div key={idx} className="text-xs"><span className="text-gray-500 break-words">{item.question}:</span> <span className="text-gray-900 font-medium">{item.answer}</span></div>
            ))}
          </div>
          <button onClick={this.handleBackToQuiz} className="mt-2 text-xs hover:underline" style={{ color: colorElements }}>← Изменить ответы</button>
        </div>

        <form onSubmit={this.handleSubmit} className="space-y-3">
          {/* Какой продукт вас интересует — обязательное */}
          <div>
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
              Какой продукт вас интересует <span className="text-red-500">*</span>
            </label>
            <input type="text" name="productName" value={formData.productName || ''} onChange={this.handleFormChange}
              placeholder="Например: антифриз, теплоноситель"
              className={`w-full px-3 py-2 rounded-xl border focus:ring-2 focus:outline-none text-sm ${errors.productName ? 'border-red-500' : 'border-gray-300'}`}
              style={{ backgroundColor: settings.color_inputs || '#FFFFFF' }} />
            {errors.productName && <p className="text-red-500 text-xs mt-1">{errors.productName}</p>}
          </div>

          {/* Количество — необязательное */}
          <div>
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Количество</label>
            <input type="text" name="quantity" value={formData.quantity || ''} onChange={this.handleFormChange}
              placeholder="Например: 10 тонн"
              className="w-full px-3 py-2 rounded-xl border border-gray-300 focus:ring-2 focus:outline-none text-sm"
              style={{ backgroundColor: settings.color_inputs || '#FFFFFF' }} />
          </div>

          {/* Название компании — необязательное */}
          <div>
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Название компании</label>
            <input type="text" name="companyName" value={formData.companyName || ''} onChange={this.handleFormChange}
              className="w-full px-3 py-2 rounded-xl border border-gray-300 focus:ring-2 focus:outline-none text-sm"
              style={{ backgroundColor: settings.color_inputs || '#FFFFFF' }} />
          </div>

          {/* Контактное лицо — обязательное */}
          <div>
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
              Контактное лицо <span className="text-red-500">*</span>
            </label>
            <input type="text" name="contactPerson" value={formData.contactPerson || ''} onChange={this.handleFormChange}
              className={`w-full px-3 py-2 rounded-xl border focus:ring-2 focus:outline-none text-sm ${errors.contactPerson ? 'border-red-500' : 'border-gray-300'}`}
              style={{ backgroundColor: settings.color_inputs || '#FFFFFF' }} />
            {errors.contactPerson && <p className="text-red-500 text-xs mt-1">{errors.contactPerson}</p>}
          </div>

          {/* Телефон — обязательное */}
          <div>
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
              Телефон <span className="text-red-500">*</span>
            </label>
            <IMaskInput mask="+7 (000) 000-00-00" value={formData.phone || ''} onAccept={this.handlePhoneChange}
              className={`w-full px-3 py-2 rounded-xl border focus:ring-2 focus:outline-none text-sm ${errors.phone ? 'border-red-500' : 'border-gray-300'}`}
              style={{ backgroundColor: settings.color_inputs || '#FFFFFF' }} lazy={true} />
            {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
          </div>

          {/* E-mail — обязательное */}
          <div>
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
              E-mail <span className="text-red-500">*</span>
            </label>
            <input type="email" name="email" value={formData.email || ''} onChange={this.handleFormChange}
              className={`w-full px-3 py-2 rounded-xl border focus:ring-2 focus:outline-none text-sm ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
              style={{ backgroundColor: settings.color_inputs || '#FFFFFF' }} />
            {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
          </div>

          {/* Комментарий — необязательное */}
          <div>
            <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">Комментарий</label>
            <textarea name="comment" value={formData.comment || ''} onChange={this.handleFormChange}
              rows="3"
              className="w-full px-3 py-2 rounded-xl border border-gray-300 focus:ring-2 focus:outline-none text-sm resize-none"
              style={{ backgroundColor: settings.color_inputs || '#FFFFFF' }} />
          </div>

          {settings.agreement_personal_data === 1 && (
            <div className="flex items-start gap-2">
              <input type="checkbox" name="agreement" checked={formData.agreement || false} onChange={this.handleFormChange} className="mt-1 flex-shrink-0" />
              <label className="text-xs text-gray-500">{settings.agreement_custom_text ? Parser(settings.agreement_custom_text) : 'Согласен на обработку данных'}</label>
            </div>
          )}
          {errors.agreement && <p className="text-red-500 text-xs">{errors.agreement}</p>}

          <button type="submit" disabled={isSending}
            className="w-full py-2 sm:py-3 rounded-xl font-semibold text-white text-sm sm:text-base transition-all hover:opacity-90 disabled:opacity-50"
            style={{ backgroundColor: colorElements }}>
            {isSending ? 'Отправка...' : (settings.widget_btn_text || 'Отправить')}
          </button>
        </form>
      </div>
    );
  };

  renderNotification = () => {
    const { notification } = this.state;
    if (!notification.show) return null;

    return (
      <div className="fixed top-4 right-4 sm:top-5 sm:right-5 z-[60] max-w-[280px] sm:max-w-[300px] p-3 rounded-lg shadow-lg animate-fadeKviz"
        style={{ backgroundColor: notification.type === 'success' ? '#f0fdf4' : '#fef2f2', border: notification.type === 'success' ? '1px solid #bbf7d0' : '1px solid #fecaca' }}>
        <div className="flex items-start gap-2">
          <div className="flex-shrink-0">
            {notification.type === 'success' ? 
              <svg className="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg> :
              <svg className="w-4 h-4 text-red-500" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>
            }
          </div>
          <p className={`text-xs ${notification.type === 'success' ? 'text-green-800' : 'text-red-800'}`}>{notification.message}</p>
          <button onClick={() => this.setState({ notification: { ...this.state.notification, show: false } })} className="flex-shrink-0 text-gray-400 hover:text-gray-600">
            <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" /></svg>
          </button>
        </div>
      </div>
    );
  };

  render() {
    const settings = this.getSettings();
    const questions = this.getQuestions();
    const { currentStep, showForm, submitted, showStartPage } = this.state;

    if (showStartPage && settings.show_start_page === 1) {
      return (
        <div className="bg-white rounded-2xl overflow-hidden" style={{ backgroundColor: settings.color_background_sidebar || '#FFFFFF' }}>
          <div className="p-4 sm:p-5">{this.renderStartPage()}</div>
          {this.renderNotification()}
        </div>
      );
    }

    if (submitted) {
      return (
        <div className="bg-white rounded-2xl overflow-hidden" style={{ backgroundColor: settings.color_background_sidebar || '#FFFFFF' }}>
          <div className="p-4 sm:p-5 text-center">
            <div className="text-4xl sm:text-5xl mb-3">🎉</div>
            <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{settings.widget_page_thanks_text || 'Спасибо!'}</h2>
            <p className="text-gray-600 text-xs sm:text-sm">{settings.widget_page_after_thanks_text}</p>
            <button onClick={this.handleRestart} className="mt-4 px-4 py-2 rounded-lg text-white text-xs sm:text-sm transition-all hover:opacity-90" style={{ backgroundColor: this.getColorElements() }}>Пройти снова</button>
          </div>
        </div>
      );
    }

    return (
      <>
        <div className="bg-white rounded-2xl overflow-hidden" style={{ backgroundColor: settings.color_background_sidebar || '#FFFFFF' }}>
          {settings.show_expert === 1 && (
            <div className="p-3 border-b flex flex-wrap items-center gap-x-[15px] gap-y-[10px]" style={{ backgroundColor: settings.color_background_sidebar || '#FFFFFF' }}>
              <a href="/" className="flex items-center gap-2 flex-none">
                <img src={this.props.data?.logo} alt='logo' width={186} height={48} className='flex-none hide-ru' />
                <img src={this.props.data?.enlogo} alt='logo' width={186} height={48} className='flex-none hide-en' />
              </a>
              {/* Знак «Сделано в России» — рядом с логотипом */}
              <MadeInRussia variant='horizontal' className='w-[130px] max-w-full' imgClassName='w-full' />
            </div>
          )}
          <div className="p-4 sm:p-5">
            {!showForm ? this.renderQuestion(questions[currentStep], currentStep) : this.renderForm()}
          </div>
          {!quizData.hideCopyright && (
            <div className="text-center py-2 text-xs text-gray-400 border-t">
              {settings.translate?.brand || 'Сделано в'} <a href={quizData.partnerLink} target="_blank" rel="noopener noreferrer" className="hover:underline">Envybox</a>
            </div>
          )}
        </div>
        {this.renderNotification()}
      </>
    );
  }
}

export default Kviz;